import { useState, useEffect, createContext } from 'react';

export type HssState = {}

const HssStore = createContext<HssState>({});

const { Provider } = HssStore;

export const HssProvider = ({ children }: any) => {
  const [hssState, setHssState] = useState<HssState>({});

  useEffect(() => {
    setHssState({});
  }, []);

  return <Provider value={hssState}>{children}</Provider>;
}
